export default "__VITE_ASSET__DXiJ545x__"